import { firebaseMutations } from 'vuexfire'
import firebaseApp from './../firebase-setup'
// import * as getterConstants from './getterConstants'
// これが使えない
// const currentUserId = (firebaseApp.auth().currentUser) ? firebaseApp.auth().currentUser.uid : null
// currentUser情報はrootStateに登録され

// plugins
// Vue生成時に実行される関数の集まり

export const repositoryModule = {
  namespaced: true,
  state: {
    isAllowedIPAddressForManagement: true,
    isAllowedIPAddress: true,
    isEdittingProfile: false
  },
  mutations: {
    ...firebaseMutations,
    setEdittingProfile (state, flag) {
      state.isEdittingProfile = flag
    },
    setIsAllowedIPAddressForManagement (state, flag) {
      console.log('set wheather this ipaddress is allowed or not ::: flag :', flag)
      state.isAllowedIPAddressForManagement = flag
    },
    setIsAllowedIPAddress  (state, flag) {
      console.log('set wheather this ipaddress is allowed or not ::: flag :', flag)
      state.isAllowedIPAddress = flag
    }
  },
  actions: {
    setEdittingProfileTrue (context) {
      context.commit('setEdittingProfile', true)
    },
    setEdittingProfileFalse (context) {
      context.commit('setEdittingProfile', false)
    },
    setIsAllowedIPAddressForManagement (context, flag) {
      context.commit('setIsAllowedIPAddressForManagement', flag)
    },
    setIsAllowedIPAddress (context, flag) {
      context.commit('setIsAllowedIPAddress', flag)
    },
    setIsAllowedIPAddressForManagementFromAPI (context) {
      const getIsAllowedAddressForManagement = firebaseApp.functions().httpsCallable('getIsAllowedAddressForManagement')
      getIsAllowedAddressForManagement().then(result => {
        let isAllowed
        if (result && result.data && result.data.isAllowed) {
          isAllowed = result.data.isAllowed
        } else {
          isAllowed = false
        }
        context.commit('setIsAllowedIPAddressForManagement', isAllowed)
      })
    },
    setIsAllowedIPAddressFromAPI (context) {
      const getIsAllowedAddress = firebaseApp.functions().httpsCallable('getIsAllowedAddress')
      getIsAllowedAddress().then(result => {
        let isAllowed
        if (result && result.data && result.data.isAllowed) {
          isAllowed = result.data.isAllowed
        } else {
          isAllowed = false
        }
        context.commit('setIsAllowedIPAddress', isAllowed)
      })
    }
    // keyresultはサーバー側で削除
  },
  getters: {
    getEdittingProfileFlag: state => state.isEdittingProfile,
    getIsAllowedIPAddressForManagement: (state) => {
      return state.isAllowedIPAddressForManagement
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/repository.js